import React, { useEffect } from "react";
import * as RB from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllDistricts } from "../../../reducers/allDistrictSlice";
import { fetchAllCities } from "../../../reducers/allCitySlice";

function AreaLocation({
  formData,
  handleInputChange,
  setFormData,
  isEdit,
  props,
}) {
  const states = useSelector((state) => state.state.states);
  const Alldistricts = useSelector((state) => state.allDis.Alldistricts);
  const Allcities = useSelector((state) => state.allcity.Allcities);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllCities());
    dispatch(fetchAllDistricts());
  }, []);
  
  const handleStateMultiSelect = (selectedList, selectedItem) => {
    const managerIds = selectedList.map((item) => item.cat).join(",");
    setFormData({
      ...formData,
      multi_state: managerIds,
    });
  };

  const handleStateRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    const updatedReportingManager = formData.multi_state
      .split(",")
      .filter((id) => id !== removedId);

    setFormData({
      ...formData,
      multi_state: updatedReportingManager.join(","),
    });
  };

  const handleCityMultiSelect = (selectedList, selectedItem) => {
    const managerIds = selectedList.map((item) => item.cat).join(",");
    setFormData({
      ...formData,
      multi_city: managerIds,
    });
  };

  const handleCityRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    const updatedReportingManager = formData.multi_city
      .split(",")
      .filter((id) => id !== removedId);

    setFormData({
      ...formData,
      multi_city: updatedReportingManager.join(","),
    });
  };

  const handleDisMultiSelect = (selectedList, selectedItem) => {
    const managerIds = selectedList.map((item) => item.cat).join(",");
    setFormData({
      ...formData,
      multi_dis: managerIds,
    });
  };

  const handleDisRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    const updatedReportingManager = formData.multi_dis
      .split(",")
      .filter((id) => id !== removedId);

    setFormData({
      ...formData,
      multi_dis: updatedReportingManager.join(","),
    });
  };

  return (
    <>
      <h6 className="mt-2">Area Location</h6>
      <hr className="hr-lg mt-1" />
      <RB.Row>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Area Location"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Area Location"
                name="area_location"
                value={formData.area_location}
                onChange={handleInputChange}
                required
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div
            className={`mb-3 ${
              formData.multi_state.length !== 0 ? "" : "mt-4"
            }`}
          >
            <Multiselect
              name="it_setup"
              displayValue="key"
              id="css_custom"
              onKeyPressFn={function noRefCheck() {}}
              onRemove={handleStateRemove}
              className={`${
                formData.multi_state.length !== 0 ? "emp_multiselect" : ""
              }`}
              onSearch={function noRefCheck() {}}
              onSelect={handleStateMultiSelect}
              options={states.map((it) => ({
                cat: it.state_code,
                key: it.state_name,
              }))}
              selectedValues={
                isEdit
                  ? states
                      .filter((plan) =>
                        props.rowData.area_state
                          .split(",")
                          .includes(plan.state_code.toString())
                      )
                      .map((plan) => ({
                        cat: plan.state_code,
                        key: plan.state_name,
                      }))
                  : ""
              }
              placeholder="Select State.."
              customCloseIcon={
                <>
                  <i class="material-icons-outlined md14 ms-1">cancel</i>
                </>
              }
              style={{
                chips: {
                  background: "#FFDE1B",
                  color: "#000000",
                  borderRadius: "1rem",
                },
                multiselectContainer: {
                  zIndex: 100000,
                },
                searchBox: {
                  border: "none",
                  borderBottom: "1px solid #dee2e6",
                  borderRadius: "0px",
                },
              }}
            />
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div
            className={`mb-3 ${
              formData.multi_state.length !== 0 ? "" : "mt-4"
            }`}
          >
            <Multiselect
              name="it_setup"
              displayValue="key"
              id="css_custom"
              onKeyPressFn={function noRefCheck() {}}
              onRemove={handleDisRemove}
              className={`${
                formData.multi_dis.length !== 0 ? "emp_multiselect" : ""
              }`}
              onSearch={function noRefCheck() {}}
              onSelect={handleDisMultiSelect}
              options={Alldistricts.map((it) => ({
                cat: it.district_code,
                key: it.district_name,
              }))}
              selectedValues={
                isEdit
                  ? Alldistricts.filter((plan) =>
                      props.rowData.area_district
                        .split(",")
                        .includes(plan.district_code.toString())
                    ).map((plan) => ({
                      cat: plan.district_code,
                      key: plan.district_name,
                    }))
                  : ""
              }
              placeholder="Select District.."
              customCloseIcon={
                <>
                  <i class="material-icons-outlined md14 ms-1">cancel</i>
                </>
              }
              style={{
                chips: {
                  background: "#FFDE1B",
                  color: "#000000",
                  borderRadius: "1rem",
                },
                multiselectContainer: {
                  zIndex: 100000,
                },
                searchBox: {
                  border: "none",
                  borderBottom: "1px solid #dee2e6",
                  borderRadius: "0px",
                },
              }}
            />
          </div>
        </RB.Col>
        {/* <RB.Col md={6}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="District"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter District"
                          name="multi_dis"
                          value={formData.multi_dis}
                          onChange={handleInputChange}
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col> */}
        <RB.Col md={6}>
          <div
            className={`mb-3 ${formData.multi_city.length !== 0 ? "" : "mt-4"}`}
          >
            <Multiselect
              name="it_setup"
              displayValue="key"
              id="css_custom"
              onKeyPressFn={function noRefCheck() {}}
              onRemove={handleCityRemove}
              className={`${
                formData.multi_state.length !== 0 ? "emp_multiselect" : ""
              }`}
              onSearch={function noRefCheck() {}}
              onSelect={handleCityMultiSelect}
              options={Allcities.map((it) => ({
                cat: it.city_code,
                key: it.city_name,
              }))}
              selectedValues={
                isEdit
                  ? Allcities.filter((plan) =>
                      props.rowData.area_city
                        .split(",")
                        .includes(plan.city_code.toString())
                    ).map((plan) => ({
                      cat: plan.city_code,
                      key: plan.city_name,
                    }))
                  : ""
              }
              placeholder="Select City.."
              customCloseIcon={
                <>
                  <i class="material-icons-outlined md14 ms-1">cancel</i>
                </>
              }
              style={{
                chips: {
                  background: "#FFDE1B",
                  color: "#000000",
                  borderRadius: "1rem",
                },
                multiselectContainer: {
                  zIndex: 10025,
                },
                searchBox: {
                  border: "none",
                  borderBottom: "1px solid #dee2e6",
                  borderRadius: "0px",
                },
              }}
            />
          </div>
        </RB.Col>
      </RB.Row>
    </>
  );
}

export default AreaLocation;
